<template>
	<div id="contacto">
		<div class="container py-5">
			<div class="row">
				<div class="col-12 h1 text-dark-pink">
					Contacto
				</div>
				<div class="col-12 mb-4 h5 text-dark-pink">
					Si tienes dudas de este proceso o necesitas más información puedes encontrarnos en:
				</div>
				<div
					class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-block d-xl-flex d-lg-flex d-md-flex text-start text-sm-center justify-content-start align-items-center">
					<img src="/assets/images/redes-sociales/redes-acompanamiento-08.png"
					     class="img-fluid red-social-icon"
					     alt=""/>
					<a href="https://www.instagram.com/uaysen.contigo/" target="_blank"
					   class="h5 text-dark-pink">@uaysen.contigo</a>
				</div>
				<div
					class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-block d-xl-flex d-lg-flex d-md-flex text-start text-sm-center justify-content-start align-items-center">
					<img src="/assets/images/redes-sociales/redes-acompanamiento-09.png"
					     class="img-fluid red-social-icon"
					     alt=""/>
					<a href="mailto:ude@uaysen.cl" target="_blank" class="h5 text-dark-pink">ude@uaysen.cl</a>
				</div>
				
				<div class="col-12 text-center d-block d-xl-none d-lg-none d-md-block d-sm-block">
					<img class="img-fluid" alt="" title=""
					     src="/assets/images/movil/esta-carrera-home-movil.png">
				</div>
			</div>
		</div>
		<div class="bg-light-yellow py-5">
			<div class="container">
				<div class="row">
					<div class="col-md-6 h2 text-dark-pink">
						<a href="https://www.uaysen.cl/" target="_blank">
							www.UAysen.cl
						</a>
					</div>
					<div class="col-md-6 d-flex justify-content-end">
						<img height="50" class="d-inline-block align-top m-0 p-0" alt="" title=""
						     src="/assets/images/nav-logo.png">
						<img height="50" class="d-inline-block align-top m-0 p-0 ms-5" alt="" title=""
						     src="/assets/images/logo-pie-uaysen-contigo.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: "main-footer",
	computed: {}
}
</script>